import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { unButtonShirtSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const UnbuttonShirtScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/unbutton-shirt-scene.png`}
      title="Shirt unbuttons. Slowly."
      choices={unButtonShirtSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
